/**
 * Brand mark – D-with-checkmark in deep blue. Source PNG lives at /logo.png
 * (served from /public). Two visual variants:
 *
 *   <Logo />              ← icon + wordmark, used in nav headers
 *   <Logo variant="mark"/> ← icon only, used in tight spaces and the footer
 *
 * The wordmark and tagline are real text (not baked into the image) so they
 * stay sharp, accessible, and easy to translate later. The image is just the
 * graphical D-tick. The tagline matches the brand: Fast · Simple · Lowest Cost.
 */
export function Logo({
  variant = 'full',
  className = '',
}: {
  variant?: 'full' | 'mark';
  className?: string;
}) {
  if (variant === 'mark') {
    return (
      <img
        src="/logo.png"
        alt="Dormant Accounts Filing"
        className={`h-8 w-8 object-contain ${className}`}
        width={32}
        height={32}
      />
    );
  }
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt=""
        aria-hidden
        className="h-9 w-9 flex-shrink-0 object-contain sm:h-10 sm:w-10"
        width={40}
        height={40}
      />
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-semibold text-brand-700 sm:text-base">
          Dormant Accounts Filing
        </span>
        <span className="hidden text-[10px] uppercase tracking-wide text-slate-500 sm:block">
          Fast · Simple · Lowest Cost
        </span>
      </div>
    </div>
  );
}
